import React from "react";
import { Link } from "react-router-dom";
import { 
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaLinkedin,
  FaInstagram,
} from "react-icons/fa";
import "../Styles/Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src={process.env.PUBLIC_URL + "/Logo.webp"} 
                alt="VEA"
                className="logo-img"
                height="70px"
              />
              <h3>Vidya Education Abroad</h3>
            </div>
            <p className="footer-description">
              Your trusted partner for immigration, study abroad, and work visa
              services. We help make your global dreams a reality with expert
              guidance and personalized support.
            </p>
            <div className="social-links">
              <Link to="https://www.facebook.com/libamigration?mibextid=wwXIfr&mibextid=wwXIfr" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </Link>
              <Link to="/" className="social-link">
                <FaLinkedin />
              </Link>
              <Link to="https://www.instagram.com/liba_migration?igsh=eDRkdXR3NWozZTdr" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </Link>
            </div>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul className="footer-links">
              <li>
                <Link to="/study">Study Abroad</Link>
              </li>
              <li>
                <Link to="/migrate">Immigration Services</Link>
              </li>
              <li>
                <Link to="/work">Work Visas</Link>
              </li>
              <li>
                <Link to="/visa">Visa Consultation</Link>
              </li>
              <li>
                <Link to="/coaching">IELTS Coaching</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/office">Our Office</Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/newsletters">Newsletters & Resources</Link>
              </li>
            </ul>
          </div>

          {/* Countries */}
          <div className="footer-section">
            <h4>Popular Destinations</h4>
            <ul className="footer-links">
              <li>
                <Link to="/study">Canada</Link>
              </li>
              <li>
                <Link to="/study">Australia</Link>
              </li>
              <li>
                <Link to="/study">United Kingdom</Link>
              </li>
              <li>
                <Link to="/study">United States</Link>
              </li>
              <li>
                <Link to="/study">New Zealand</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact Us</h4>
            <div className="contact-info">
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span>Amar Jyoti CHS, Andheri west, Mumbai </span>
              </div>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <span>+91 8850285886</span>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>info@veabroad.com</span>
              </div>
            </div>

            {/* Newsletter */}
            <div className="newsletter">
              <h5>Subscribe to Our Newsletter</h5>
              <form className="newsletter-form" onSubmit={async (e) => {
                e.preventDefault();
                const emailInput = e.target.querySelector('input[type="email"]');
                if (!emailInput.value) return;
                try {
                  // Was hardcoded to the production host, so local and staging
                  // builds posted real subscriptions at live veabroad.com.
                  const res = await fetch(
                    `${process.env.REACT_APP_API_URL || "https://veabroad.com"}/api/newsletter/`,
                    {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        email: emailInput.value,
                        category: "Newsletter",
                        source: "Footer newsletter",
                      }),
                    }
                  );
                  if (!res.ok) throw new Error(`HTTP ${res.status}`);
                  emailInput.value = "";
                  alert("Subscribed successfully!");
                } catch {
                  alert("Error subscribing. Please try again later.");
                }
              }}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="newsletter-input"
                  required
                />
                <button type="submit" className="newsletter-btn">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2026 Vidya Education Abroad. All rights reserved.</p>
            <p className="footer-credit">
              Designed and developed by{" "}
              <a
                href="https://rootcrypt.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                RootCrypt
              </a>
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/cookies">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}